export const COVERS_DATA = "COVERS_DATA";
export const REVIEWS_DATA = "REVIEWS_DATA";
export const COVER_BLOG_DATA = "COVER_BLOG_DATA";
export const COVER_ARTISTS_DATA = "COVER_ARTISTS_DATA";
export const COVER_PODCASTS_DATA = "COVER_PODCASTS_DATA";
export const COVER_MEMBERS_DATA = "COVER_MEMBERS_DATA";
export const COVER_SHOP_DATA = "COVER_SHOP_DATA";
export const COVER_VOTING_DATA = "COVER_VOTING_DATA";
export const DISCOVERS_DATA = "DISCOVERS_DATA";

//Action Creator
export const setCovers = (data) => {
    return { type: COVERS_DATA, data }
}

export const setReviews = (data) => {
    return { type: REVIEWS_DATA, data }
}

export const setCoverBlog = (data) => {
    return { type: COVER_BLOG_DATA, data }
}

export const setCoverArtists = (data) => {
    return { type: COVER_ARTISTS_DATA, data }
}

export const setCoverPodcasts = (data) => {
    return { type: COVER_PODCASTS_DATA, data }
}

export const setCoverMembers = (data) => {
    return { type: COVER_MEMBERS_DATA, data }
}

export const setCoverShop = (data) => {
    return { type: COVER_SHOP_DATA, data }
}

export const setCoverVoting = (data) => {
    return { type: COVER_VOTING_DATA, data }
}

export const setDisCovers = (data) => {
    return { type: DISCOVERS_DATA, data }
}